import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
  brandFonts,
  fontSize,
} from '../styles';
import { Container, Heading } from './ui';

const StyledTeamProfiles = styled.section`
  ${sectionPaddings()};
  background-color: ${standardColours.lighterGrey};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 30px;

  ${minBreakpointQuery.tsmall`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.smedium`
    column-gap: 50px;
  `}

  ${minBreakpointQuery.mlarge`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${minBreakpointQuery.xlarge`
    gap: 50px 70px;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 70px 90px;
  `}
`;

const StyledItem = styled.article`
  &:nth-child(odd) {
    ${minBreakpointQuery.tsmall`
      margin-top: 30px;
    `}

    ${minBreakpointQuery.smedium`
      margin-top: 50px;
    `}

    ${minBreakpointQuery.xlarge`
      margin-top: 70px;
    `}

    ${minBreakpointQuery.xxlarge`
      margin-top: 90px;
    `}
  }
`;

const StyledImageNameWrapper = styled.div`
  position: relative;
`;

const StyledName = styled.h3`
  position: absolute;
  right: 90px;
  bottom: 0;
  left: 0;
  padding: 20px 0;
  font-family: ${brandFonts.secondary};
  ${fontSize(22)};
  background-color: ${standardColours.lighterGrey};
`;

const StyledBio = styled.p`
  margin-top: 20px;
  padding-top: 20px;
  line-height: 1.9;
  white-space: break-spaces;
  border-top: 1px solid ${standardColours.lightGrey};
`;

const TeamProfiles = ({ heading, items }) => (
  <StyledTeamProfiles>
    <Container>
      <Heading>{heading}</Heading>
      <StyledItems>
        {items.map(({ id, image: { gatsbyImageData, alt }, name, bio }) => (
          <StyledItem key={id}>
            <StyledImageNameWrapper>
              <GatsbyImage image={gatsbyImageData} alt={alt} />
              <StyledName>{name}</StyledName>
            </StyledImageNameWrapper>
            <StyledBio>{bio}</StyledBio>
          </StyledItem>
        ))}
      </StyledItems>
    </Container>
  </StyledTeamProfiles>
);

export default TeamProfiles;
